export const supportTicketKeys = {
  all: ['support-tickets'] as const,
  lists: () => [...supportTicketKeys.all, 'list'] as const,
  list: (page: MaybeRef<number>, perPage: MaybeRef<number>) =>
    [...supportTicketKeys.lists(), page, perPage] as const,
  takenList: (page: MaybeRef<number>, perPage: MaybeRef<number>) =>
    [...supportTicketKeys.lists(), 'taken', page, perPage] as const,
  closedList: (page: MaybeRef<number>, perPage: MaybeRef<number>) =>
    [...supportTicketKeys.lists(), 'closed', page, perPage] as const,
  hangingList: (page: MaybeRef<number>, perPage: MaybeRef<number>) =>
    [...supportTicketKeys.lists(), 'hanging', page, perPage] as const,
  stagnantList: (page: MaybeRef<number>, perPage: MaybeRef<number>) =>
    [...supportTicketKeys.lists(), 'stagnant', page, perPage] as const,
  detail: (id: MaybeRef<number>) =>
    [...supportTicketKeys.all, 'detail', id] as const,
};
